@if (toastService.activeToasts().length > 0) {
    <div class="toast-container" aria-live="polite" aria-atomic="true">
        @for (toast of toastService.activeToasts(); track toast.id) {
            <app-toast
                [toast]="toast"
                [isExiting]="isExiting(toast.id)"
                (onClose)="closeToast($event)" />
        }
    </div>
}
